// extracted by mini-css-extract-plugin
export default {"addNewBtn":"DigitalWaiver_addNewBtn__H-0o+","description":"DigitalWaiver_description__Mh0Ll","select":"DigitalWaiver_select__3z1da"};